// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryListPageStyles } from "@turnerBlueprint/Overrides/Pages/CategoryListPage";
import { DivWrapper } from "@turnerBlueprint/XDL/constants";
import { xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

categoryListPageStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 297px) auto;
        gap: 40px 42px;
        ${xScreen("lte", "md")} {
            display: flex;
            flex-direction: column;
        }
    `,
};

categoryListPageStyles.leftSide = {
    css: css`
        & > ${DivWrapper} {
            display: flex;
            flex-direction: column;
            gap: 23px;
            max-width: 297px;
            ${xScreen("lte", "md")} {
                max-width: 100%;
                display: flex;
                flex-direction: row;
                gap: 20px;
                flex-wrap: wrap;
                & > div {
                    flex: 1;
                }
            }

            ${xScreen("lt", "sm")} {
                flex-direction: column;
                gap: 23px;
            }
        }

        ${xScreen("lte", "md")} {
            order: 2;
        }

        &:has(& > ${DivWrapper}:empty) {
            display: none;
        }
    `,
};

categoryListPageStyles.rightSide = {
    css: css`
        display: flex;
        flex: 1;
        ${xScreen("lte", "md")} {
            order: 1;
        }
    `,
};
